import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Returns a contrasting text color (dark or white) for a given hex background.
 * Uses relative luminance calculation per WCAG guidelines (4.5:1 contrast ratio).
 * @param hex - Background color in "#RRGGBB" format
 * @returns "#1a1a1a" for light backgrounds, "#ffffff" for dark backgrounds
 */
export function contrastText(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.5 ? '#1a1a1a' : '#ffffff';
}
